import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { db } from '../../../../firebase';
import { collection, onSnapshot, getDocs } from 'firebase/firestore';
import { dataLinksLoadedAction } from '../../../actions/datalinks';
import { dataCompletedAction } from '../../../actions/store';

const useDataLinksLoader = () => {
  const [options, setOptions] = useState({ execute: false });

  const dispatch = useDispatch();

  const load = () => {
    dispatch(dataCompletedAction({ slice: 'DataLinks', path: 'dataLinks' }));
    return onSnapshot(
      collection(db, 'datalinks'),
      async querySnapshot => {
        const items = [];

        querySnapshot.forEach(doc => {
          const dataItem = doc.data();
          dataItem.id = doc.id;
          items.push(dataItem);
        });

        // Load datalink_filters
        await Promise.all(
          items.map(async dataLink => {
            const filtersSnap = await getDocs(
              collection(db, `datalinks/${dataLink.id}/datalink_filters`)
            );
            dataLink.filters = filtersSnap.docs.map(doc => ({
              ...doc.data(),
              id: doc.id
            }));

            const segmentsSnap = await getDocs(
              collection(db, `datalinks/${dataLink.id}/datalink_pathsegments`)
            );
            dataLink.pathsegments = segmentsSnap.docs.map(doc => ({
              ...doc.data(),
              id: doc.id
            }));
          })
        );

        dispatch(dataLinksLoadedAction(items));
      },
      error => {
        console.error('useDataLinksLoader.onSnapshot', error);
      }
    );
  };

  useEffect(() => {
    let unSub = () => {};
    if (options.execute) {
      unSub = load();
    }
    return () => {
      unSub();
    };
  }, [options]);

  return {
    loadDataLinks: (options = {}) => {
      setOptions({ ...options, execute: true });
    }
  };
};

export default useDataLinksLoader;
